module.exports = __webpack_public_path__ + "officialStatic/img/sw-detailList13.97e12f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/sw-detailList13.png
// module id = Aov0
// module chunks = 0